import { MAX_PROJECTILES, PROJ_BOLT } from "./constants";

// Struct-of-arrays projectile store. Projectiles are the most numerous live
// entities during a battle; they get their own tight pool separate from units.
// z is height above ground for ballistic arcs (0 = ground plane).

export class Projectiles {
  alive = new Uint8Array(MAX_PROJECTILES);
  x = new Float32Array(MAX_PROJECTILES);
  y = new Float32Array(MAX_PROJECTILES);
  z = new Float32Array(MAX_PROJECTILES);
  px = new Float32Array(MAX_PROJECTILES); // previous (render interpolation)
  py = new Float32Array(MAX_PROJECTILES);
  pz = new Float32Array(MAX_PROJECTILES);
  vx = new Float32Array(MAX_PROJECTILES);
  vy = new Float32Array(MAX_PROJECTILES);
  vz = new Float32Array(MAX_PROJECTILES);
  gravity = new Float32Array(MAX_PROJECTILES);
  damage = new Float32Array(MAX_PROJECTILES);
  aoe = new Float32Array(MAX_PROJECTILES);
  owner = new Uint8Array(MAX_PROJECTILES);
  target = new Int32Array(MAX_PROJECTILES);
  ttl = new Float32Array(MAX_PROJECTILES); // seconds remaining
  ptype = new Uint8Array(MAX_PROJECTILES); // PROJ_BOLT | PROJ_ARC
  faction = new Uint8Array(MAX_PROJECTILES); // 0 vantage-look, 1 feral-look (for render color)

  private freeStack: number[] = [];
  private highWater = 0;

  spawn(): number {
    let p = this.freeStack.pop();
    if (p === undefined) {
      if (this.highWater >= MAX_PROJECTILES) return -1;
      p = this.highWater++;
    }
    this.alive[p] = 1;
    this.z[p] = 0;
    this.vz[p] = 0;
    this.gravity[p] = 0;
    this.ptype[p] = PROJ_BOLT;
    this.target[p] = -1;
    return p;
  }

  kill(p: number): void {
    if (!this.alive[p]) return;
    this.alive[p] = 0;
    this.freeStack.push(p);
  }

  get count(): number {
    return this.highWater;
  }

  liveCount(): number {
    let n = 0;
    for (let p = 0; p < this.highWater; p++) if (this.alive[p]) n++;
    return n;
  }
}
